export const hourInMilliseconds = 1000 * 60 * 60
export const dayInMilliseconds = hourInMilliseconds * 24
export const weekInMilliseconds = dayInMilliseconds * 7